<template>
    <div>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                </div>
            </div>
        </div>
        <br><br>
        <!-- end page title -->

        <!--  dashboard statistics  -->
        <div class="row grouped-multiple-statistics-card">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12 mb-lg-2">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_revenue }}
                                        </h3>
                                        <p class="sub-heading">Total Revenue</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12 mb-lg-2">
                                <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-cab customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_ongoing_rides }}
                                        </h3>
                                        <p class="sub-heading">On going Rides</p>
                                        `
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12 mb-lg-2">
                                <div class="d-flex align-items-start">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-cab customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_completed_rides }}
                                        </h3>
                                        <p class="sub-heading">Total Completed Rides</p>
                                        `
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_drivers }}
                                        </h3>
                                        <p class="sub-heading">Drivers</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12">
                                <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_passengers }}
                                        </h3>
                                        <p class="sub-heading">Passengers</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-4 col-sm-6 col-12">
                                <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon info d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_fleets }}
                                        </h3>
                                        <p class="sub-heading">Fleet Managers</p>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  end dashboard statistics  -->

        <!--  Recent rides -->
        <div class="row grouped-multiple-statistics-card">
            <div class="col-xl-12 col-lg-12">
                <div class="card" style="">
                    <div class="card-header">
                        <h4 class="card-title">Recent Rides</h4>
                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                        <div class="heading-elements">
                            <ul class="list-inline mb-0">
                                <li><a data-action="reload"><i class="feather icon-rotate-cw"></i></a></li>
                                <li><a data-action="expand"><i class="feather icon-maximize"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <p>Total rides today <b>{{ latest_trips.total_trips }}</b>. <span class="float-right">
                            <a :href="route('admin.trips.index')" target="_blank">Full ride history <i
                                class="feather icon-arrow-right"></i></a></span></p>
                        </div>
                        <div class="table-responsive">
                            <table id="recent-orders" class="table table-hover mb-0 ps-container ps-theme-default">
                                <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>RideId#</th>
                                    <th>Driver Name</th>
                                    <th>Passenger Name</th>
                                    <th>Time Completed</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(trip, i) in latest_trips.trips" :key="trip.id">
                                    <td class="text-truncate">{{ i + 1 }}</td>
                                    <td class="text-truncate"> {{ trip.id }}</td>
                                    <td class="text-truncate">
                                        {{ trip.driver.first_name + ' ' + trip.driver.first_name }}
                                    </td>
                                    <td class="text-truncate">
                                        {{ trip.passenger.first_name + ' ' + trip.passenger.first_name }}
                                    </td>
                                    <td class="text-truncate">{{ formatDateTime(trip.created_at) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End  Recent rides -->

        <!--  Recent User Activities -->
        <div class="row grouped-multiple-statistics-card">
            <div class="col-xl-12 col-lg-12">
                <div class="card" style="">
                    <div class="card-header">
                        <h4 class="card-title">Recent User Activities</h4>
                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                        <div class="heading-elements">
                            <ul class="list-inline mb-0">
                                <li><a data-action="reload"><i class="feather icon-rotate-cw"></i></a></li>
                                <li><a data-action="expand"><i class="feather icon-maximize"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <table id="recent-user-activites"
                                   class="table table-hover mb-0 ps-container ps-theme-default">
                                <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>Log Name</th>
                                    <th>Log</th>
                                    <th>Time</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(activity, i) in latest_user_activities" :key="activity.id">
                                    <td class="text-truncate">{{ i + 1 }}</td>
                                    <td class="text-truncate"> {{ activity.log_name }}</td>
                                    <td class="text-truncate">{{ activity.description }}</td>
                                    <td class="text-truncate">{{ activity.created_at }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End  Recent rides -->


    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Echo from 'laravel-echo'

export default {
    metaInfo: { title: 'Dashboards' },
    name: 'Dashboard',
    layout: Layout,
    props: [
        'total_revenue', 'total_drivers', 'total_passengers', 'total_ongoing_rides',
        'latest_user_activities', 'latest_trips', 'total_fleets', 'total_completed_rides'
    ],

    data: () => ({
        echo: null,
        realTimeData: {
            newRides: 0,
            completedRides: 0
        }
    }),

    mounted() {
        // alert('Test event received: ' + data.message);

        // this.initializeEcho()
        // this.listenToEvents()
        // this.loaded = true
    },

    methods: {
        // initializeEcho() {
        //     this.echo = new Echo({
        //         broadcaster: 'reverb',
        //         key: process.env.MIX_REVERB_APP_KEY,
        //         wsHost: window.location.hostname,
        //         wsPort: process.env.MIX_REVERB_PORT || 80,
        //         wssPort: process.env.MIX_REVERB_SSL_PORT || 443,
        //         forceTLS: false, // set to true in production
        //         enabledTransports: ['ws', 'wss'],
        //     })
        // },

        listenToEvents() {
            this.echo.channel('test-channel')
                .listen('.test.event', (data) => {
                    console.log('Test event received:', data.message);
                    // You could show a notification or update UI
                    alert('Test event received: ' + data.message);
                });

            // Example: Listen for new ride events
            // this.echo.channel('dashboard-updates')
            //     .listen('.ride.created', (data) => {
            //         this.realTimeData.newRides++
            //         console.log('New ride created:', data)
            //         // You could also update your props or trigger UI updates here
            //     })
            //     .listen('.ride.completed', (data) => {
            //         this.realTimeData.completedRides++
            //         console.log('Ride completed:', data)
            //     })

            // For private channels (if needed)
            // this.echo.private(`driver.${this.user.id}`)
            //     .listen('.driver.assigned', (data) => {...})
        },
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    },

    beforeDestroy() {
        // Clean up Echo connection when component is destroyed
        if (this.echo) {
            this.echo.disconnect()
        }
    }
}
</script>
